export const sectionDividerWidth = 17; // 1px + 16px Padding
export const rowDividerWidth = 9; // 1px + 8px Padding
